import { lendingApiFetchJson } from 'lendingApi/lendingApi';
import { buildAddressLabel } from 'utils/addressBuilder';
import { URLS } from 'utils/tests/urls.config';
import {
  TDeserialisedIntroducerFormData,
  TSubmitRegistrationParams,
  TTitle,
} from './registration.types';

export const submitRegistration = async ({
  values,
  onSuccess,
  onError,
}: TSubmitRegistrationParams) => {
  const introducerValues = {
    // Fixes type error as values.title can be 'herr' | 'frau' whereas lapi client types expect UK values only
    title: values.title as TTitle,
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    phone_number: values.phoneNumber,
  };

  try {
    if (values.uuid) {
      // Using lendingApiFetchJson as we need to send the FE tokens due to the user not being logged in
      await lendingApiFetchJson(URLS.postIntroducer(), {
        method: 'post',
        body: JSON.stringify({
          data: { ...introducerValues, introducer_company_id: values.uuid },
        }),
      });
    } else {
      await lendingApiFetchJson(URLS.postIntroducerAccount(), {
        method: 'post',
        body: JSON.stringify({
          data: {
            introducer_account: {
              introducer_type: values.introducerType,
              public_facing_company_name: values.companyTradingName,
              address: values.registeredTradingAddress,
              company_name: values.companyName,
              company_number: values.companyNumber,
              email: values.email,
              fca_reference: values.FCAReferenceNumber,
              phone_number: values.phoneNumber,
              post_code: values.postcode,
              vat_number: values.vatNumber,
              website: values.companyWebsite,
            },
            introducer: {
              ...introducerValues,
            },
          },
        }),
      });
    }
    onSuccess();
    return;
  } catch {
    onError();
  }
};

export const generateUKAddress = (
  values: Omit<TDeserialisedIntroducerFormData, 'registeredTradingAddress'>,
) => {
  return buildAddressLabel([
    values.addressLine1,
    values.addressLine2,
    values.town,
  ]);
};
